import { takeLatest, put, call } from 'redux-saga/effects';

import { listControlePragaDoenca } from '../service';

import {
  TABLE_CONTROLE_PRAGA_DOENCA,
  TABLE_CONTROLE_PRAGA_DOENCA_PENDING,
  TABLE_CONTROLE_PRAGA_DOENCA_SUCCESS,
  TABLE_CONTROLE_PRAGA_DOENCA_FAILURE
} from '../actionTypes';

function* sagaListControlePragaDoenca(action) {
  yield put({ type: TABLE_CONTROLE_PRAGA_DOENCA_PENDING })

  try {
    const table = yield call(listControlePragaDoenca, action.args)
    yield put({ type: TABLE_CONTROLE_PRAGA_DOENCA_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_CONTROLE_PRAGA_DOENCA_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListControlePragaDoenca() {
  yield takeLatest(TABLE_CONTROLE_PRAGA_DOENCA, sagaListControlePragaDoenca)
}
